export const getDisabledButtonSx = (disabled: boolean = false) => {
  return disabled
    ? {
        cursor: "wait",
      }
    : {};
};

export const getButtonOnClick = (fn: () => void, disabled: boolean = false) => {
  return disabled ? () => {} : fn;
};

export const TruncatedTextUptoLine = (lines: number = 1) => {
  return {
    display: "-webkit-box",
    WebkitBoxOrient: "vertical" as "vertical",
    overflow: "hidden",
    WebkitLineClamp: lines,
  };
};

export const formatDecimal = (value: number) => {
  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") || "{}");
  const { roundOff = false, decimalPlaces = 2 } = ConfigDictionary.decimalFormatting || {};
  if (roundOff) {
    return value.toFixed(decimalPlaces);
  }
  return truncateToTwoDecimals(value, decimalPlaces);
};

export const  truncateToTwoDecimals = (number: number, decimalPlaces: number = 2): string => {
  if (!number && number !== 0) return ""
  const str = number.toString();
  const decimalIndex = str.indexOf('.');
  if (decimalIndex === -1) return str;  // No decimal, return as is
  return str.slice(0, decimalIndex + decimalPlaces + 1);
}


export const getUomLabel = () => {
  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") || "{}");
  const { caseUnitLabel, otherUnitLabel, packUnitLabel, designationBasedUomSecondary} = ConfigDictionary;
  const designationEnabled  =  designationBasedUomSecondary?.enable ?? false;
  const availableDesignations = designationBasedUomSecondary?.roles?.designationKeys?.map(((item: { type: any; }) => item?.type)) || [];
  const currentDesignation = JSON.parse(localStorage.authContext).user.designation || [];
  const designation = availableDesignations.find((type: any) => 
    currentDesignation.includes(type)
  );
  const designationKeys = designationBasedUomSecondary?.roles?.designationKeys ?? [];
  const matchedRole = designationKeys.find((role: { type: string; uomAllowed: any }) => role.type === designation);
  if(designationEnabled && designation && designationKeys && matchedRole){
    return {
      caseUnitLabel:matchedRole.uomAllowed.case ? caseUnitLabel : "",
      otherUnitLabel:matchedRole.uomAllowed.other ? otherUnitLabel : "",
      packUnitLabel:matchedRole.uomAllowed.piece ? packUnitLabel : "",
    }
  }
  return {
    caseUnitLabel,
    otherUnitLabel,
    packUnitLabel,
  }
}


export const getQuantityType = ()=>{
  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") || "{}");
  const {designationBasedUomSecondary} = ConfigDictionary;
  const designationEnabled  =  designationBasedUomSecondary?.enable ?? false;
  const availableDesignations = designationBasedUomSecondary?.roles?.designationKeys?.map(((item: { type: any; }) => item?.type)) || [];
  const currentDesignation = JSON.parse(localStorage.authContext).user.designation || [];

  const designation = availableDesignations.find((type: any) => 
    currentDesignation.includes(type)
  );
  
  const designationKeys = designationBasedUomSecondary?.roles?.designationKeys ?? [];
  const matchedRole = designationKeys.find((role: { type: string; uomAllowed: any }) => role.type === designation);

  if(designationEnabled && designation && designationKeys && matchedRole){
    if(matchedRole.uomAllowed.case){
      return "caseQty";
    }
    if(matchedRole.uomAllowed.other){
      return "otherQty";
    }
    if(matchedRole.uomAllowed.piece){
      return "pieceQty";
    }
  }else{
    return "";
  }
}

export const fetchSessionStorageFilter = (filterKey: string) => {
  const sessionData = sessionStorage.getItem('sessionStorageDmsFilters');
  if (!sessionData) return null;
  const filterValue = JSON.parse(sessionData)?.[filterKey];
    return filterValue;
}

export const updateSessionStorageFilter = (filterKey: string, newFilterValue: string) => {
  const sessionData = sessionStorage.getItem('sessionStorageDmsFilters');
  let sessionObj: Record<string, any> = {};
  if (sessionData) {
    try {
      sessionObj = JSON.parse(sessionData);
    } catch (error) {
      console.warn('Invalid session storage JSON. Resetting.', error);
    }
  }
  sessionObj[filterKey] = newFilterValue;
  sessionStorage.setItem('sessionStorageDmsFilters', JSON.stringify(sessionObj));
}
export const filterDataForSearch = (allData: any[], filterKeys:string[], searchStr:string)=>{
  searchStr = searchStr.toLowerCase();
  return allData.filter(data=>{
    for(const key in filterKeys){
      const splitKey = key.split(",");
      let val = data;
      for(const key in filterKeys){
        val = val[key];
      }
      if(val.toLowerCase().includes(searchStr)){
        return true;
      }
    }
    return false;
  })
}

export const featuresWithShortcutKeys: Record<string, string> = {
  SECONDARY: "O",
  PRIMARY: "G",
  STOCKS: "S",
  DELIVERY: "L",
  CLAIMS: "R",
  "MDM AND INTEGRATION": "M",
  SETTLEMENTS: "D",
};

export function showUom(uom: string, createPrimaryOrderUom: string){
    if (!createPrimaryOrderUom) return true
    return uom === createPrimaryOrderUom
  }

 export const isUserAllowedToEdit = (orderEditAllowedRoles: string[]) => {
    const userDesignation = JSON.parse(localStorage.authContext)?.user?.designation || [];
    if (!Array.isArray(userDesignation)) {
      return false; 
    }
    return userDesignation.some(designation => orderEditAllowedRoles.includes(designation));
  };

  export const truncateString = (str: string, l:number): string => {
    if (str.length <= l) {
      return str;
    }
    return str.slice(0, l) + "...";
  };

  export const safeStringify = (data: any): string => {
    try {
      return JSON.stringify(data);
    } catch (e) {
      return `Stringify failed: ${(e as Error)?.message || e}`;
    }
  }
  
export const handleScroll = (
  e: React.WheelEvent<HTMLDivElement>,
  setIsScrolling: React.Dispatch<React.SetStateAction<boolean>>,
  scrollTop: number 
) => {
  if (e.deltaY > 0) {
    setIsScrolling(true); // scrolling down
  } else if (e.deltaY < 0 && scrollTop === 0) {
    setIsScrolling(false); // scrolling up
  } 
};

  
export const handleScrollCSO = (
  e: React.WheelEvent<HTMLDivElement>,
  setExpandForm: React.Dispatch<React.SetStateAction<boolean>>,
  scrollTop: number 
) => {
  if (e.deltaY > 0) {
    setExpandForm(false); // scrolling down
  } else if (e.deltaY < 0 && scrollTop === 0) {
    setExpandForm(true); // scrolling up
  } 
};



export const handleScrollCustomDataGrid = (
  e: React.WheelEvent<HTMLDivElement>,
  setIsScrolling: React.Dispatch<React.SetStateAction<boolean>>
) => {
  const target = e.target as HTMLElement;
  if (e.deltaY > 0) {
    setIsScrolling(true); // scrolling down
  } else if (e.deltaY < 0 && !target.closest(".ignore-scroll-detection")) {
    setIsScrolling(false); // scrolling up
  }
};


export function createScrollHandler(
  scrollRef: React.RefObject<HTMLElement>,
  isScrolling: boolean,
  setAllowTableScroll: (value: boolean) => void,
  setDontContainerScroll: (value: boolean) => void
) {
  return function handleScrollInnerComponent() {
    if (!scrollRef.current) return;

    const { scrollTop, scrollHeight, clientHeight } = scrollRef.current;
    const isAtBottom = scrollTop + clientHeight >= scrollHeight - 1;

    setDontContainerScroll(!isScrolling && scrollTop === 0);

    if (isAtBottom) {
      setAllowTableScroll(true);
    } else {
      setAllowTableScroll(false);
    }
  };
}

export function formatAmount(amount: number, currencySymbol: string): string {
  if (amount >= 1_00_00_000) {
    return `${currencySymbol}${truncateToTwoDecimals(amount / 1_00_00_000)}Cr`;
  } else if (amount >= 1_00_000) {
    return `${currencySymbol}${truncateToTwoDecimals(amount / 1_00_000)}L`;
  } else if (amount >= 1_000) {
    return `${currencySymbol}${truncateToTwoDecimals(amount / 1_000)}K`;
  }
  return `${currencySymbol}${truncateToTwoDecimals(amount)}`;
}

export const removeFromSessionStorage = () => {
  sessionStorage.removeItem("bulkInvoiceFilterData");
}